import { useEffect, useState } from 'react';
import { useFeatureFlags } from './FeatureFlagsContext';

/** 18 juillet 2026 · 11h30 à Paris (CEST, UTC+2) → 09h30 UTC */
export const WEDDING_DATE = new Date('2026-07-18T09:30:00Z');

export function getWeddingCountdownRemainingMs(now = Date.now()): number {
  return Math.max(0, WEDDING_DATE.getTime() - now);
}

export function isWeddingCountdownReached(now = Date.now()): boolean {
  return getWeddingCountdownRemainingMs(now) === 0;
}

export function useWeddingCountdownReached(): boolean {
  const [reached, setReached] = useState(() => isWeddingCountdownReached());

  useEffect(() => {
    if (reached) {
      return undefined;
    }

    const id = window.setInterval(() => {
      if (isWeddingCountdownReached()) {
        setReached(true);
      }
    }, 1000);

    return () => window.clearInterval(id);
  }, [reached]);

  return reached;
}

export function usePhotoboothEnabled(): boolean {
  const { ENABLE_PHOTOBOOTH } = useFeatureFlags();
  const countdownReached = useWeddingCountdownReached();
  return ENABLE_PHOTOBOOTH || countdownReached;
}

export function useQuestEnabled(): boolean {
  const { ENABLE_QUEST } = useFeatureFlags();
  const countdownReached = useWeddingCountdownReached();
  return ENABLE_QUEST || countdownReached;
}
